import { Condition } from "@redotech/redo-model/return-flow/condition";
import { validatePackageProtectionCondition } from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type PackageProtectionState = void;

export const PACKAGE_PROTECTION = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<PackageProtectionState>
  >,
): ConditionType<PackageProtectionState, Condition.PackageProtection> => ({
  name: "Covered by package protection",
  description() {
    return "Customer purchased package protection";
  },
  Details(props: ConditionTypeDetailsProps<PackageProtectionState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.PACKAGE_PROTECTION };
  },
  valid() {
    return validatePackageProtectionCondition({}).valid;
  },
});
